import { MODULES, FEATURES } from '@src/quince-site-common/src/constants/template-info'
import wishListStateManager from '@src/quince-site-common/src/redux/globalStateManager/WishlistStateManager'
import productService from '@src/quince-site-common/src/services/productService'
import { IWishlistItem } from '@src/quince-site-common/src/services/Wishlist.types'
import wishlistService from '@src/quince-site-common/src/services/wishlistService'
import AuthUtil from '@src/quince-site-common/src/utils/authUtil'
import { captureException } from '@src/quince-site-common/src/utils/sentryUtil'

import { SharedWishListDataType, WishlistItem } from './wishlist.types'

export const fetchUserWishListProducts = async (): Promise<WishlistItem[]> => {
  try {
    const wishlistItems: IWishlistItem[] = AuthUtil.isLoggedIn()
      ? await wishlistService.wishListAlreadyLoggedIn(AuthUtil.getUser().email ?? '')
      : wishlistService.fetchUserWishListFromLocalStorage()
    wishListStateManager.setWishlistTotalItemsCount(wishlistItems.length)

    const productList = await productService.getProductCards({
      shopifyProductIds: wishlistItems.map((wishlistItem: IWishlistItem) => wishlistItem.product_id),
      colors: wishlistItems.map((wishlistItem: IWishlistItem) => wishlistItem.color),
    })
    return productList
  } catch (error) {
    captureException(error, {
      module: MODULES.WISHLIST,
      feature: FEATURES.FETCH_WISHLIST_PRODUCTS,
    })
    return []
  }
}

export const fetchSharedWishList = async (id: string): Promise<SharedWishListDataType> => {
  const res = await wishlistService.getSharedWishlist(id)
  const wishListItems = res.wishlist ?? []

  const ownWishListItems = AuthUtil.isLoggedIn()
    ? await wishlistService.wishListAlreadyLoggedIn(AuthUtil.getUser().email ?? '')
    : wishlistService.fetchUserWishListFromLocalStorage()

  wishListStateManager.setWishlistTotalItemsCount(ownWishListItems.length)
  const productList = await productService.getProductCards({
    shopifyProductIds: wishListItems.map(wishListItems => wishListItems.product_id),
    colors: wishListItems.map(wishListItems => wishListItems.color),
  })
  return { wishListItems: productList, name: res.user_name }
}
